
scittle.kixi_stats.init();